// Player States - Export all states for easy importing

export { default as BaseState } from './BaseState';
export { default as IdleState } from './IdleState';
export { default as RollingState } from './RollingState';
export { default as JumpingState } from './JumpingState';
export { default as FallingState } from './FallingState';
export { default as DeadState } from './DeadState';

// State name constants
export const PlayerStates = {
    IDLE: 'idle',
    ROLLING: 'rolling',
    JUMPING: 'jumping',
    FALLING: 'falling',
    DEAD: 'dead'
};
